import { render, staticRenderFns } from "./IndexDefault.vue?vue&type=template&id=6ac71a99&scoped=true"
import script from "./IndexDefault.vue?vue&type=script&lang=js"
export * from "./IndexDefault.vue?vue&type=script&lang=js"
import style0 from "./IndexDefault.vue?vue&type=style&index=0&id=6ac71a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac71a99",
  null
  
)

export default component.exports